import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsConditions = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-white text-gray-800 font-sans">
            <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
                <button
                    onClick={() => navigate('/')}
                    className="flex items-center gap-2 text-amber-700 hover:text-amber-800 font-semibold mb-8 transition-colors"
                >
                    <ArrowLeft size={20} />
                    Back to Home
                </button>

                <h1 className="text-4xl font-bold text-gray-900 mb-8 border-b pb-4 border-amber-100">Terms & Conditions</h1>

                <div className="space-y-6 text-lg leading-relaxed">
                    <p>
                        Welcome to Nayan's Kitchen & Delights! By accessing our website, placing an order, or using any of our services, you agree to comply with and be bound by the following Terms and Conditions. Please review them carefully.
                    </p>

                    <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">1. Acceptance of Terms</h2>
                    <p>
                        By accessing this website, you are agreeing to be bound by these website Terms and Conditions of Use, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws.
                    </p>

                    <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">2. Offerings and Delivery</h2>
                    <p>
                        We prepare the finest Maharashtrian dishes and offer next-day delivery (T+1 system) to ensure freshness. Orders placed today will be confirmed and processed for delivery by the next available slot.
                    </p>

                    <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">3. Payment Methods</h2>
                    <p>
                        We accept various secure online payments including credit/debit cards, UPI, Wallets via gateways like Razorpay, PhonePe, and Paytm. All payments are securely processed and your transactions are encrypted.
                    </p>

                    <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">4. Limitations</h2>
                    <p>
                        In no event shall Nayan's Kitchen & Delights or its suppliers be liable for any damages arising out of the use or inability to use the materials on Nayan's Kitchen & Delights website, even if Nayan's Kitchen & Delights or an authorized representative has been notified orally or in writing of the possibility of such damage.
                    </p>

                    <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">5. Revisions</h2>
                    <p>
                        The materials appearing on Nayan's Kitchen & Delights website could include technical, typographical, or photographic errors. Nayan's Kitchen & Delights does not warrant that any of the materials on its website are accurate, complete, or current. We may make changes to the materials contained on the website at any time without notice.
                    </p>

                    <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">6. Contact Information</h2>
                    <p>
                        For any queries regarding the terms, please contact us at hellonayanskitchen@gmail.com.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TermsConditions;
